import React from 'react'
import { Link } from "gatsby"
import Photo01 from '../assets/Design.png'
import Photo02 from '../assets/Coaching.jpg'

const HeaderCoaching = () => {
    return (
        <div className='text-center'>
            <div class="py-5 px-5 uppercase tracking-wide font-size-ronsof-p5 text-sm text-white font-bold">O que é coaching?
            </div>
           <div class=" container6 justify-center flex mt-4 md:mt-0 md:ml-6">
                
                <div class="space-x-5 animasion1 padding-90 font-size-ronsof-p6 mt-2 text-white">
                    O coaching é um processo direcionado com começo, 
                    meio e fim, fundamentado em estudos científicos de 
                    diversas áreas, e com o objetivo principal de atingir 
                    uma meta. Este processo é realizado entre 8 e 10 encontros, 
                    guiados por um profissional altamente qualificado que utiliza
                    métodos e ferramentas específicas que contribuem para
                    potencializar o desempenho pessoal e profissional do cliente, 
                    além de auxiliá-lo a buscar novas compreensões e alternativas
                    e a desenvolver novas habilidades. O que pensam grandes líderes
                    mundiais sobre o coaching? ASSISTA AO VÍDEO!    
                </div>
                <iframe className='py-5 animasion3 '  width="900" height="250" src="https://www.youtube.com/embed/w8RwTf2pmj0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe> 
            </div>
            
        </div>    
    )
}
export default HeaderCoaching